<div class="numpad-error" *ngIf="message"><span [innerHtml]="message" (click)="onClick()"> </span></div>
